import React from "react";
import { Chip, Skeleton, Box } from "@mui/material";
const CategorySkeleton = () => {
  const SkeletonItem = ({ ...rest }) => (
    <Skeleton
      variant="rounded"
      sx={{ margin: ".7rem auto", borderRadius: 16 }}
      {...rest}
    >
      <Chip />
    </Skeleton>
  );
  return (
    <Box
      spacing={2}
      sx={{
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
      }}
    >
      <SkeletonItem width={46} height={32} />
      <SkeletonItem width={73} height={32} />
      <SkeletonItem width={69} height={32} />
      <SkeletonItem width={81} height={32} />
      <SkeletonItem width={60} height={32} />
      <SkeletonItem width={68} height={32} />
    </Box>
  );
};

export default CategorySkeleton;
